import { waLink } from "../../data/site";
import { Reveal } from "./Reveal";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const FinalCTA = () => (
  <section data-testid="final-cta-section" className="relative overflow-hidden bg-champagne-light px-4 py-24 sm:px-6 sm:py-32 lg:px-8">
    <div className="pointer-events-none absolute -right-40 top-0 h-[480px] w-[480px] rounded-full bg-champagne/15 blur-3xl" />
    <div className="pointer-events-none absolute -left-40 bottom-0 h-[380px] w-[380px] rounded-full bg-white/5 blur-3xl" />

    <div className="relative mx-auto max-w-4xl text-center">
      <Reveal>
        <div className="mx-auto mb-10 h-28 w-28 overflow-hidden rounded-full border-2 border-champagne/50 bg-surface shadow-xl">
          <img
            src="/assets/leo-face.jpg"
            alt="Leomar Ramos, consultor de planos de saúde"
            data-testid="final-cta-consultant-photo"
            className="h-full w-full object-cover"
          />
        </div>
        <h2 className="mx-auto max-w-3xl font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl lg:text-5xl">
          Vou encontrar uma opção que{" "}
          <em className="italic text-champagne-dark">faça sentido para você.</em>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-stone-400 sm:text-lg">
          Conte o que você procura e receba uma análise personalizada das opções
          disponíveis para o seu perfil.
        </p>
        <p className="mt-6 font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-champagne-dark">
          Pessoa física • Dependentes • Empresas
        </p>
      </Reveal>

      <Reveal delay={0.2} className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
        <a
          href={waLink("Olá! Quero minha cotação de plano de saúde.")}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="final-cta-whatsapp"
          className="group inline-flex items-center gap-3 rounded-full bg-wa px-9 py-4 text-sm font-bold text-white shadow-[0_14px_50px_-12px_rgba(37,211,102,0.55)] transition-[background-color,transform] duration-300 hover:-translate-y-1 hover:bg-wa-dark"
        >
          <WhatsAppIcon className="h-5 w-5 transition-transform duration-300 group-hover:rotate-6" />
          Quero minha cotação
        </a>
        <a
          href={waLink("Olá, Leomar! Gostaria de conversar sobre planos de saúde.")}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="final-cta-leo"
          className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-9 py-4 text-sm font-semibold text-ink transition-[border-color,background-color,transform] duration-300 hover:-translate-y-1 hover:border-white/40 hover:bg-white/10"
        >
          Falar com Leomar
        </a>
      </Reveal>
    </div>
  </section>
);
